
  import WikiDetails from '@/components/WikiDetails';
  import jobsSearchUrlHelper from '@/helper/jobsSearchUrlHelper';

  export default {
    name: 'SectionWikiDetails',
    components: {
      WikiDetails,
      RelatedWikis: () => import('@/components/RelatedWikis'),
      RelatedJobs: () => import('@/components/RelatedJobs'),
      RelatedEvents: () => import('@/components/RelatedEvents.vue'),
      ShareElement: () => import('@/components/ShareElement'),
      JobAlert: () => import('@/components/JobAlert'),
    },
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        metaData: {},
        seoContentConfig: {},
        wiki: {},
      };
    },
    created() {
      this.wiki = this.section.wiki;
    },
    methods: {
      jobsSearchUrl() {
        return jobsSearchUrlHelper(
          this.wiki.filterParams,
          this.$auth.loggedIn,
          this.$auth.user?.candidateProfile?.addresses[0]
        );
      },
    },
  };
